const formField = { className: 'mt-2 shadow-sm border-info' }
const inlineForm = { className: 'mt-3 mb-2 shadow-sm border-info' }
const fixedForm = { className: 'shadow-sm border-info' }
const normalButton = { className: 'mt-3 mb-2 py-1 shadow-sm' }
const fixedButton = { className: 'py-1 shadow-sm' }
const bubble = {
  style: { background: '#f1f3f6' },
  className:
    'border rounded shadow-sm pt-2 pe-5 ps-5 pb-2 border-info w-auto mb-4 mt-3 ',
}
const link = {
  style: { textDecoration: 'underline', fontWeight: 'bold', color: '#0680b5' },
}
const tall = { className: 'pt-1 pb-1' }

export default {
  formField,
  fixedForm,
  inlineForm,
  normalButton,
  fixedButton,
  bubble,
  link,
  tall,
}
